/* __next_internal_client_entry_do_not_use__ RenderCategoryLayoutElement auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { isSupportedBanner, LayoutElementBasedBanner } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/LayoutElementBasedBanner";
import { LayoutElementBasedCarousel } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/LayoutElementBasedCarousel";
import { TitleStyles } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/styles/TitleStyles";
import { TrackedLinkContext } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE, MAX_CONTENT_WIDTH, MAX_WIDE_SCREEN_CONTENT_WIDTH } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { ShowroomEducationCarousel } from "@faire/retailer-visitor-shared/features/Showroom/ApparelCategory/ShowroomEducationCarousel";
import { ShowroomTitleBanner } from "@faire/retailer-visitor-shared/features/Showroom/ApparelCategory/ShowroomTitleBanner";
import { useRecordMilestoneByDay } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { ProductTileImpressionsProvider } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/ProductTileImpressionsProvider";
import { ElevatedContentWrapper } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackCategoriesLayoutElementCtaClick } from "@faire/web-api--source/events/categories/click/layoutElementCta";
import { trackCategoriesLayoutElementItemClick } from "@faire/web-api--source/events/categories/click/layoutElementItem";
import { trackCategoriesLayoutElementView } from "@faire/web-api--source/events/categories/view/layoutElement";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { SHOWROOM_APPAREL_C1_TITLE_BANNER } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SHOWROOM_APPAREL_C1_TITLE_BANNER";
import React from "react";
import styled, { css } from "styled-components";
var DEFAULT_EMBLA_CAROUSEL_ARROW_OFFSET = 0;
export var RenderCategoryLayoutElement = function(props) {
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    var recordMilestoneByDay = useRecordMilestoneByDay();
    var eventPathPrefix = "/category-homepage/".concat(props.layoutElement.on_click_event_name, "/").concat(props.layoutElement.placement);
    var renderTallCategoryTileCarousel = function() {
        var _layoutElement_layout_element_data_map, _layoutElement_layout_element_data;
        var MINIMUM_NUMBER_OF_CATEGORY_TILES = 3;
        var layoutElement = props.layoutElement, _props_requestId = props.requestId, requestId = _props_requestId === void 0 ? "" : _props_requestId;
        var _layoutElement_layout_element_data_map_filter;
        var tiles = (_layoutElement_layout_element_data_map_filter = (_layoutElement_layout_element_data = layoutElement.layout_element_data) === null || _layoutElement_layout_element_data === void 0 ? void 0 : (_layoutElement_layout_element_data_map = _layoutElement_layout_element_data.map(function(layoutElementData) {
            var _layoutElementData_category_tile;
            return (_layoutElementData_category_tile = layoutElementData.category_tile) !== null && _layoutElementData_category_tile !== void 0 ? _layoutElementData_category_tile : layoutElementData.simple_image_title;
        })) === null || _layoutElement_layout_element_data_map === void 0 ? void 0 : _layoutElement_layout_element_data_map.filter(isNotUndefined)) !== null && _layoutElement_layout_element_data_map_filter !== void 0 ? _layoutElement_layout_element_data_map_filter : [];
        if (tiles.length < MINIMUM_NUMBER_OF_CATEGORY_TILES) {
            return null;
        }
        var isBelowBreadcrumb = layoutElement.placement === ILayoutElement.Placement.BELOW_BREADCRUMB;
        var _layoutElement_display_page;
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, {
                requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                layoutElement: _object_spread_props(_object_spread({}, layoutElement), {
                    display_page: (_layoutElement_display_page = layoutElement.display_page) !== null && _layoutElement_display_page !== void 0 ? _layoutElement_display_page : ILayoutElement.DisplayPage.CATEGORY_PAGE
                }),
                onCTAClick: trackCategoriesLayoutElementCtaClick,
                onItemClick: trackCategoriesLayoutElementItemClick,
                onVisible: trackCategoriesLayoutElementView,
                peekNext: true,
                peekNextPercent: isMobile ? 10 : 4,
                itemGap: 4,
                leftAlignTitle: true,
                arrowOffsetX: DEFAULT_EMBLA_CAROUSEL_ARROW_OFFSET,
                $isBelowBreadcrumb: isBelowBreadcrumb,
                $maxWidth: MAX_WIDE_SCREEN_CONTENT_WIDTH,
                $lessTopMargin: true
            })
        });
    };
    var renderBrandCarousel = function() {
        var category = props.category, layoutElement = props.layoutElement, requestId = props.requestId;
        var navigationPath = category === null || category === void 0 ? void 0 : category.navigationPath;
        return /*#__PURE__*/ _jsx(StyledBrandCarousel, {
            $maxWidth: MAX_WIDE_SCREEN_CONTENT_WIDTH,
            children: /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarouselBottomMargin, {
                requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                layoutElement: layoutElement,
                onCTAClick: trackCategoriesLayoutElementCtaClick,
                onItemClick: trackCategoriesLayoutElementItemClick,
                onVisible: trackCategoriesLayoutElementView,
                brandPageQueryParams: {
                    refC: navigationPath
                },
                itemsPerSlide: {
                    mobileAndAbove: 2,
                    tabletAndAbove: 4,
                    desktopAndAbove: 5,
                    xLargeAndAbove: 6
                },
                arrowOffsetX: DEFAULT_EMBLA_CAROUSEL_ARROW_OFFSET
            })
        });
    };
    var renderProductCarousel = function() {
        var layoutElement = props.layoutElement, requestId = props.requestId, className = props.className, category = props.category;
        var isBelowBreadcrumb = layoutElement.placement === ILayoutElement.Placement.BELOW_BREADCRUMB;
        var itemGap = {
            mobileAndAbove: 8,
            tabletAndAbove: 16
        };
        return /*#__PURE__*/ _jsx(ProductTileImpressionsProvider, {
            requestId: requestId,
            category: category,
            onClickEventName: layoutElement.on_click_event_name,
            children: /*#__PURE__*/ _jsx(TrackedLinkContext.Provider, {
                value: {
                    requestId: requestId,
                    type: IClickInfo.Type.PRODUCT,
                    containerName: eventPathPrefix
                },
                children: /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, {
                    recordAdImpression: true,
                    requestId: requestId !== null && requestId !== void 0 ? requestId : "",
                    itemGap: itemGap,
                    itemsPerSlide: {
                        mobileAndAbove: 2,
                        tabletAndAbove: 4,
                        desktopAndAbove: 5,
                        xLargeAndAbove: 6
                    },
                    $isBelowBreadcrumb: isBelowBreadcrumb,
                    layoutElement: layoutElement,
                    onCTAClick: trackCategoriesLayoutElementCtaClick,
                    onItemClick: trackCategoriesLayoutElementItemClick,
                    onVisible: trackCategoriesLayoutElementView,
                    leftAlignTitle: true,
                    pageType: PAGE_TYPE.CATEGORY,
                    showArrowCTA: isMobile,
                    className: className,
                    peekNextPercent: {
                        mobileAndAbove: 10,
                        tabletAndAbove: 0
                    },
                    productPageQueryParams: {
                        refC: category === null || category === void 0 ? void 0 : category.navigationPath
                    },
                    arrowOffsetX: DEFAULT_EMBLA_CAROUSEL_ARROW_OFFSET,
                    $maxWidth: MAX_WIDE_SCREEN_CONTENT_WIDTH
                })
            })
        });
    };
    var renderShowroomEducationCarousel = function() {
        var layoutElement = props.layoutElement, requestId = props.requestId, category = props.category, className = props.className;
        return /*#__PURE__*/ _jsx(StyledShowroomEducationCarousel, {
            layoutElement: layoutElement,
            requestId: requestId,
            category: category,
            className: className
        });
    };
    var renderShowroomTitleBanner = function() {
        var layoutElement = props.layoutElement, requestId = props.requestId, category = props.category, className = props.className;
        return /*#__PURE__*/ _jsx(MobileWrapper, {
            children: /*#__PURE__*/ _jsx(ShowroomTitleBanner, {
                layoutElement: layoutElement,
                requestId: requestId,
                category: category,
                className: className
            })
        });
    };
    var renderSampleRequestCarousel = function() {
        var layoutElement = props.layoutElement, requestId = props.requestId;
        var commonProps = {
            requestId: requestId !== null && requestId !== void 0 ? requestId : "",
            layoutElement: layoutElement,
            onItemClick: trackCategoriesLayoutElementItemClick,
            onVisible: trackCategoriesLayoutElementView,
            itemsPerSlide: {
                mobileAndAbove: 2,
                tabletAndAbove: 4,
                desktopAndAbove: 5,
                xLargeAndAbove: 6
            },
            leftAlignTitle: true,
            arrowOffsetX: DEFAULT_EMBLA_CAROUSEL_ARROW_OFFSET
        };
        var isBelowBreadcrumb = layoutElement.placement === ILayoutElement.Placement.BELOW_BREADCRUMB;
        return /*#__PURE__*/ _jsx(StyledSampleRequestCarousel, {
            $maxWidth: MAX_WIDE_SCREEN_CONTENT_WIDTH,
            $isBelowBreadcrumb: isBelowBreadcrumb,
            children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                tabletAndBelow: /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, _object_spread_props(_object_spread({}, commonProps), {
                    itemGap: 8
                })),
                desktop: /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, _object_spread_props(_object_spread({}, commonProps), {
                    itemGap: 16
                })),
                xLargeAndAbove: /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, _object_spread({}, commonProps))
            })
        });
    };
    var renderNoOpElement = function() {
        var layoutElement = props.layoutElement, requestId = props.requestId;
        return /*#__PURE__*/ _jsx(NoOpLayoutElementCarousel, {
            hideTitle: true,
            layoutElement: layoutElement,
            requestId: requestId !== null && requestId !== void 0 ? requestId : "",
            onItemClick: trackCategoriesLayoutElementItemClick,
            onVisible: trackCategoriesLayoutElementView,
            pageType: PAGE_TYPE.CATEGORY
        });
    };
    var renderDynamicAutoColumnGrid = function() {
        var omitCategoryPageStyling = props.omitCategoryPageStyling, layoutElement = props.layoutElement, requestId = props.requestId;
        return /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, {
            requestId: requestId !== null && requestId !== void 0 ? requestId : "",
            layoutElement: layoutElement,
            $isBelowBreadcrumb: !omitCategoryPageStyling,
            $applyMobileMargins: !omitCategoryPageStyling
        });
    };
    var renderDynamicSparseGrid = function() {
        var omitCategoryPageStyling = props.omitCategoryPageStyling, layoutElement = props.layoutElement, requestId = props.requestId;
        return /*#__PURE__*/ _jsx(StyledLayoutElementBasedCarousel, {
            requestId: requestId !== null && requestId !== void 0 ? requestId : "",
            layoutElement: layoutElement,
            hideTitle: true,
            $isBelowBreadcrumb: !omitCategoryPageStyling,
            $applyMobileMargins: !omitCategoryPageStyling
        });
    };
    var onLayoutElementBannerVisible = function(containerName, requestId, tokens) {
        var layoutElement = props.layoutElement;
        if (layoutElement.type === ILayoutElement.Type.MID_PRICE_POINT_PLUS_CATEGORY_HOME_PAGE_HEADER_BANNER) {
            recordMilestoneByDay(SHOWROOM_APPAREL_C1_TITLE_BANNER);
        }
        if (layoutElement.type === ILayoutElement.Type.MULTI_IMAGE_TITLE_BANNER) {
            var _layoutElement_layout_element_data;
            var layoutElementDataTokens = (_layoutElement_layout_element_data = layoutElement.layout_element_data) === null || _layoutElement_layout_element_data === void 0 ? void 0 : _layoutElement_layout_element_data.map(function(layoutElementData) {
                var _layoutElementData_simple_image_title;
                return (_layoutElementData_simple_image_title = layoutElementData.simple_image_title) === null || _layoutElementData_simple_image_title === void 0 ? void 0 : _layoutElementData_simple_image_title.event_tracking_token;
            }).filter(isNotUndefined);
            var displayedBrandTokens = isDesktopAndAbove ? layoutElementDataTokens : layoutElementDataTokens === null || layoutElementDataTokens === void 0 ? void 0 : layoutElementDataTokens.slice(0, 1);
            var _displayedBrandTokens_join;
            trackCategoriesLayoutElementView(containerName, requestId, (_displayedBrandTokens_join = displayedBrandTokens === null || displayedBrandTokens === void 0 ? void 0 : displayedBrandTokens.join(" ")) !== null && _displayedBrandTokens_join !== void 0 ? _displayedBrandTokens_join : "");
            return;
        }
        trackCategoriesLayoutElementView(containerName, requestId, tokens);
    };
    var renderLayoutElementBasedBanner = function() {
        var layoutElement = props.layoutElement, requestId = props.requestId;
        return /*#__PURE__*/ _jsx(StyledLayoutElementBasedBanner, {
            layoutElement: layoutElement,
            requestId: requestId !== null && requestId !== void 0 ? requestId : "",
            onCTAClick: trackCategoriesLayoutElementCtaClick,
            onItemClick: trackCategoriesLayoutElementItemClick,
            onVisible: onLayoutElementBannerVisible,
            pageType: PAGE_TYPE.CATEGORY
        });
    };
    var renderHorizontalLine = function() {
        return /*#__PURE__*/ _jsx(HorizontalLine, {
            "data-test-id": "layout-element-horizontal-line",
            className: "hidden md:block lg:max-w-[1440px] md:[&&&]:mx-auto md:[&&&]:mt-8 lg:[&&&]:my-10"
        });
    };
    if (props.isLoading) {
        return null;
    }
    switch(props.layoutElement.type){
        case ILayoutElement.Type.TALL_CATEGORY_TILE:
            return renderTallCategoryTileCarousel();
        case ILayoutElement.Type.SMALL_MAKER_TILE_CAROUSEL:
            return renderBrandCarousel();
        case ILayoutElement.Type.PRODUCT_TILE_CAROUSEL:
        case ILayoutElement.Type.BUY_FROM_SAMPLES_CAROUSEL:
            return renderProductCarousel();
        case ILayoutElement.Type.SHOP_MID_PRICE_POINT_PLUS_PRODUCTS_BANNER:
            return renderShowroomEducationCarousel();
        case ILayoutElement.Type.MID_PRICE_POINT_PLUS_PAGE_TITLE:
            return renderShowroomTitleBanner();
        case ILayoutElement.Type.SAMPLE_REQUEST_CAROUSEL:
            return renderSampleRequestCarousel();
        case ILayoutElement.Type.NO_OP_LAYOUT_ELEMENT:
            return renderNoOpElement();
        case ILayoutElement.Type.DYNAMIC_SPARSE_GRID:
            return renderDynamicSparseGrid();
        case ILayoutElement.Type.DYNAMIC_GRID_OR_CAROUSEL:
            return renderDynamicAutoColumnGrid();
        case ILayoutElement.Type.HORIZONTAL_LINE:
            return renderHorizontalLine();
    }
    if (isSupportedBanner(props.layoutElement.type)) {
        return renderLayoutElementBasedBanner();
    }
    return null;
};
var fullWidthLayoutElement = css([
    "width:calc(100% + ",
    "px);margin-left:-",
    "px;margin-right:-",
    "px;"
], MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE * 2, MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE, MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE);
var wrapperStyle = css([
    "",
    "{margin-bottom:48px;}margin-bottom:40px;",
    "{",
    "}"
], responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.mobile, fullWidthLayoutElement);
var StyledLayoutElementBasedBanner = styled(LayoutElementBasedBanner).withConfig({
    componentId: "sc-5a963072-0"
})([
    "",
    ""
], function(props) {
    if (props.layoutElement.type === ILayoutElement.Type.FULL_WIDTH_IMAGE_BANNER) {
        return css([
            "",
            "{margin-bottom:",
            ";}",
            "{margin-bottom:",
            ";}"
        ], responsiveMediaQueries.mobile, getSpacing("1/2x"), responsiveMediaQueries.tabletAndAbove, getSpacing(12));
    }
    if (props.layoutElement.type === ILayoutElement.Type.COMMUNITY_CATEGORY_BANNER) {
        return css([
            "margin-bottom:",
            ";"
        ], getSpacing("3x"));
    }
    if (props.layoutElement.type === ILayoutElement.Type.MULTI_IMAGE_TITLE_BANNER) {
        return css([
            "width:100%;max-width:1920px;margin:0 auto;",
            "{background-color:unset;}"
        ], responsiveMediaQueries.mobile);
    }
    if (props.layoutElement.type === ILayoutElement.Type.SHOWROOM_VALUES_TITLE_BANNER) {
        return css([
            "margin-bottom:",
            ";",
            "{",
            "}"
        ], getSpacing("2x"), responsiveMediaQueries.tabletAndBelow, fullWidthLayoutElement);
    }
    return css([
        ""
    ]);
});
var NoOpLayoutElementCarousel = styled(LayoutElementBasedCarousel).withConfig({
    componentId: "sc-5a963072-1"
})([
    "margin:0;"
]);
var StyledLayoutElementBasedCarousel = styled(LayoutElementBasedCarousel).withConfig({
    componentId: "sc-5a963072-2"
})([
    "",
    " ",
    "{",
    "{padding-left:20px;}}",
    ""
], wrapperStyle, TitleStyles.Container, responsiveMediaQueries.mobile, function(param) {
    var $isBelowBreadcrumb = param.$isBelowBreadcrumb, $applyMobileMargins = param.$applyMobileMargins, $maxWidth = param.$maxWidth, $lessTopMargin = param.$lessTopMargin;
    return $isBelowBreadcrumb ? css([
        "",
        "{width:100%;",
        " padding:",
        ";}",
        "{max-width:",
        "px;",
        "}",
        "{padding:",
        ";}",
        "{",
        " width:100%;",
        "{padding-left:",
        ";}padding:0px ",
        ";}"
    ], responsiveMediaQueries.tabletAndAbove, $lessTopMargin ? css([
        "margin:",
        " auto ",
        ";"
    ], getSpacing("2x"), getSpacing("5x")) : css([
        "margin:",
        " auto 0;"
    ], getSpacing("4x")), getSpacing(0, "6x"), responsiveMediaQueries.desktopAndAbove, $maxWidth !== null && $maxWidth !== void 0 ? $maxWidth : MAX_CONTENT_WIDTH, $lessTopMargin ? css([
        "margin:",
        " auto ",
        ";"
    ], getSpacing("2x"), getSpacing("6x")) : css([
        "margin:",
        " auto 0;"
    ], getSpacing("5x")), responsiveMediaQueries.xLargeAndAbove, getSpacing(0, "6x"), responsiveMediaQueries.mobile, $lessTopMargin ? css([
        "margin:",
        " auto ",
        ";"
    ], getSpacing("2x"), getSpacing("4x")) : css([
        "margin:",
        " auto 0;"
    ], getSpacing("4x")), TitleStyles.Container, getSpacing("2x"), $applyMobileMargins ? getSpacing("2x") : "auto") : "";
});
var StyledLayoutElementBasedCarouselBottomMargin = styled(StyledLayoutElementBasedCarousel).withConfig({
    componentId: "sc-5a963072-3"
})([
    "margin-bottom:",
    ";",
    "{margin-bottom:",
    ";}"
], getSpacing("4x"), responsiveMediaQueries.tabletAndAbove, getSpacing("6x"));
var StyledSampleRequestCarousel = styled.div.withConfig({
    componentId: "sc-5a963072-4"
})([
    "",
    "{padding:",
    ";",
    "{",
    "}",
    "}",
    "{display:none;",
    "{display:inline-block;}}",
    "{display:none;",
    "{display:inline-block;}}"
], StyledLayoutElementBasedCarousel, getSpacing("2x", 0), responsiveMediaQueries.tabletAndAbove, function(param) {
    var $isBelowBreadcrumb = param.$isBelowBreadcrumb;
    return $isBelowBreadcrumb ? css([
        "padding:",
        ";"
    ], getSpacing("6x")) : css([
        "padding:",
        ";"
    ], getSpacing("5x"));
}, function(param) {
    var $isBelowBreadcrumb = param.$isBelowBreadcrumb, $maxWidth = param.$maxWidth;
    return $isBelowBreadcrumb && $maxWidth ? css([
        "max-width:",
        "px;margin:auto;width:auto;"
    ], $maxWidth) : "";
}, TitleStyles.AuxiliaryTitleArrow, responsiveMediaQueries.mobile, TitleStyles.AuxiliaryTitleText, responsiveMediaQueries.tabletAndAbove);
var MobileWrapper = styled.div.withConfig({
    componentId: "sc-5a963072-5"
})([
    "",
    "{width:calc(100% + ",
    "px);margin:0 -",
    "px;}"
], responsiveMediaQueries.mobile, MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE * 2, MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE);
var StyledShowroomEducationCarousel = styled(ShowroomEducationCarousel).withConfig({
    componentId: "sc-5a963072-6"
})([
    "",
    ""
], wrapperStyle);
var StyledBrandCarousel = styled(ElevatedContentWrapper).withConfig({
    componentId: "sc-5a963072-7"
})([
    "&&&{",
    "{padding:0 ",
    ";width:100%;}",
    "{margin:0 auto;padding:",
    ";}",
    "{margin:0 auto;}}"
], responsiveMediaQueries.mobile, getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, getSpacing(0, "6x"), responsiveMediaQueries.desktopAndAbove);
